import { render, staticRenderFns } from "./ConfigurationCompare.vue?vue&type=template&id=0925d8ae&"
import script from "./ConfigurationCompare.vue?vue&type=script&lang=js&"
export * from "./ConfigurationCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports